export default __webpack_public_path__ + "static/1666-3399ca111d69997bf65d01606b76b87b.gif";